import { render, staticRenderFns } from "./Switzerland.vue?vue&type=template&id=519dfcaa&"
import script from "./Switzerland.vue?vue&type=script&lang=js&"
export * from "./Switzerland.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('519dfcaa')) {
      api.createRecord('519dfcaa', component.options)
    } else {
      api.reload('519dfcaa', component.options)
    }
    module.hot.accept("./Switzerland.vue?vue&type=template&id=519dfcaa&", function () {
      api.rerender('519dfcaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/Switzerland.vue"
export default component.exports